import React from 'react'
import { Tooltip } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import {
  AlertAcceptanceStatus,
  AlertTriggeredBy,
  RequirementEvaluationProfileAlert,
} from '@shared/types'
import { originalIcons } from '@shared/components/icons/icons'
import { TableRequirement } from '@modules/company-profile/requirements-table.component'

interface Props {
  requirement: TableRequirement
  isActive: boolean
}

const getAlertTitle = (
  alert: RequirementEvaluationProfileAlert,
  isActive: boolean
) => {
  if (!isActive) {
    if (alert.triggeredBy === AlertTriggeredBy.AddingNewRequirementBase) {
      return 'Nowe wymaganie, wymagane zapoznanie się.'
    }

    return 'Treść tego wymagania zmieniła się, wymagane zapoznanie się.'
  }

  if (alert.triggeredBy === AlertTriggeredBy.AddingNewRequirementBase) {
    return 'Nowe wymaganie.'
  }

  return 'Treść tego wymagania zmieniła się od czasu wykonania audytu. Potwierdzenie aktualności statusu wymaga ponownej oceny.'
}

export const TableAlertIndicatorComponent = ({
  requirement,
  isActive,
}: Props) => {
  const classes = useStyles()

  if (!requirement.alert) {
    return null
  }

  return (
    <Tooltip
      title={getAlertTitle(requirement.alert!, isActive)}
      aria-label="deprecation-warning"
    >
      <originalIcons.Error
        className={classes.deprecatedWarning}
        color={
          requirement.alert.acceptanceStatus === AlertAcceptanceStatus.Accepted
            ? 'success'
            : 'error'
        }
      />
    </Tooltip>
  )
}

const useStyles = makeStyles((theme) => ({
  deprecatedWarning: {
    marginTop: 6,
  },
}))
